import React, { Component } from "react";
import api from "../../services/api";
import { withRouter } from '../../common/with-router';
import { Container, Row, Col, Card, Spinner, InputGroup, FormControl } from "react-bootstrap";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import logomarca from '../../assets/images/logo-hns-branco.png';
import Style from './Login.module.css'
import { getCurrentUser } from '../../common/utils';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

class TrocarSenha extends Component {
    constructor(props) {
        super(props);
        this.handleResetar = this.handleResetar.bind(this);
        this.onChangePassword = this.onChangePassword.bind(this);
        this.onChangeConfPassword = this.onChangeConfPassword.bind(this);        

        this.state = {
            password: "",
            confPassword: "",
            showPassword: false,
            showConfPassword: false,       
            loading: false,
            programa_dados: [],
        };
    }

    onChangePassword(e) {
        this.setState({
            password: e.target.value
        });
    }

    onChangeConfPassword(e) {
        this.setState({
            confPassword: e.target.value
        });
    }

    toggleShowPassword = () => {
        this.setState(state => ({ showPassword: !state.showPassword }));
    };

    toggleShowConfPassword = () => {
        this.setState(state => ({ showConfPassword: !state.showConfPassword }));
    };

    handleResetar(e) {
        const { t } = this.props;
        const MySwal = withReactContent(Swal) 

        e.preventDefault();

        //verifica se senha e confirmação são iguais
        if(this.state.password != this.state.confPassword){
            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: <p>{t('login:alert.passwordMismatch')}</p>,
            })

            return false;
        }

        this.setState({
            loading: true
        });

        let payload = {
            'password': this.state.password,
        }        
        
        api({
            method: 'PUT',
            url: '/usuarios/minha_conta/',
            data: payload
        })
        .then(response => {            
            this.setState({
                loading: false,
            })            

            //remove a flag
            localStorage.removeItem("trocar_senha")

            MySwal.fire({
                title: t('login:alert.passwordChangedTitle'),
                icon: 'success',
                html: t('login:alert.passwordChangedText'),
                showCloseButton: true,
            }).then((result) => {
                this.props.router.navigate("/");  
                window.location.reload();
            });                      
        })
        .catch(error => {
            let erro_msg = t('login:alert.changeFailed');            

            if(error.response && error.response.status === 500){
                erro_msg = t('messages:error.server');
            }
            else if(error.response && error.response.status === 400){
                const campos = error.response.data;                
                
                //percorre os campos com erro
                for (let key in campos){
                    var value = campos[key];
                };
            }

            MySwal.fire({
                icon: 'error',
                showCloseButton: true,
                title: t('layout:notifications.alert.title'),
                html: <p>{erro_msg}</p>,
            })    
            
            this.setState({
                loading: false,
            })
        });
    }

    render() {      
        const { t } = this.props;
        const {
            loading,
            password,
            confPassword,
            showPassword,
            showConfPassword
        } = this.state;

        const dados_usuario = getCurrentUser();
        
        return (
            <div className="login-page">
                <Container>
                    <Row>
                        <Col lg={{ span: 4, offset: 4 }} sm={{ span: 6, offset: 3 }} xs={12}>              
                            <div className="text-center mb-4">    
                                <img src={logomarca} alt="Aditus" />
                            </div>       
                            <Card className="mt-5">
                                <Card.Body>
                                    <h4>{t('login:newPassword.title')}</h4>
                                    <form onSubmit={this.handleResetar}>                                        
                                        <div className="form-group mb-3">
                                            <label>{t('login:newPassword.password')}</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showPassword ? 'text' : 'password'}
                                                value={password}
                                                required
                                                onChange={this.onChangePassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowPassword}
                                                >
                                                {showPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <div className="form-group mb-3">
                                            <label>{t('login:newPassword.confirmation')}</label>
                                            <InputGroup>
                                                <FormControl
                                                type={showConfPassword ? 'text' : 'password'}
                                                value={confPassword}
                                                required
                                                onChange={this.onChangeConfPassword}
                                                />
                                                <InputGroup.Text
                                                className={Style.clickable}
                                                onClick={this.toggleShowConfPassword}
                                                >
                                                {showConfPassword ? <FaEyeSlash /> : <FaEye />}
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </div>
                                        <p>{t('login:newPassword.requirements.title')}</p>
                                        <ul>
                                            <li>{t('login:newPassword.requirements.length')}</li>
                                            <li>{t('login:newPassword.requirements.lowercase')}</li>
                                            <li>{t('login:newPassword.requirements.uppercase')}</li>
                                            <li>{t('login:newPassword.requirements.digit')}</li>
                                            <li>{t('login:newPassword.requirements.special')}</li>
                                        </ul>
                                        <div className="form-group mb-2 text-center">
                                            <button
                                                className="btn btn-first mt-3 btn-block"
                                                disabled={loading}
                                            >
                                                {loading && (
                                                    <span className="spinner-border spinner-border-sm"></span>
                                                )}
                                                <span>{t('login:newPassword.submit')}</span>
                                            </button>
                                        </div>                                       
                                    </form>                        
                                </Card.Body>
                            </Card>                                              
                        </Col>
                    </Row>
                </Container>
            </div>
        );
        
    }
}

TrocarSenha.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation(['login', 'common', 'messages', 'layout'])(withRouter(TrocarSenha));